import Typography from '@mui/material/Typography';
import { COLORS } from 'config/constants';
import './avatar.scss';

const ChatAvatar = () => <div className='chat-avatar' aria-hidden='true'>
  <Typography component='span' sx={{
    position: 'absolute',
    left: '9px',
    top: '-2.5px',
    width: '15px',
    height: '32px',
    textAlign: 'right',
    fontFamily: 'Help Source Code Pro, monospace',
    fontSize: '24px',
    fontWeight: 700,
    lineHeight: 1.34,
    color: COLORS.BLUE,
    letterSpacing: 0,
  }}>→</Typography>
</div>;

export default ChatAvatar;
